import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import useEffectAsync from '../../../hooks/useEffectAsync'
import PerMonthPerTherapistChart from '../charts/PerMonthPerTherapistChart'
import { client } from '../../../client'
import ChartNoData from '../charts/ChartNoData'

const formatEuro = (value) =>
  typeof value === 'number'
    ? value.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
    : value

const RevenuePerMonthPerTherapist = () => {
  const { t } = useTranslation('statisticsPage')
  const [data, setData] = useState([])

  useEffectAsync(async () => {
    setData(await client.getRevenuePerMonthSplitByTherapist())
  }, [])

  const title = t('getRevenuePerMonthSplitByTherapist')
  if (!data.length) return <ChartNoData title={title} />

  const convertedData = data.map((item) => {
    const newItem = { ...item }
    delete newItem.jaar
    return {
      ...newItem,
      maand: `${item.maand} ${item.jaar}`
    }
  })

  const getPsychologists = [...new Set(convertedData.map((el) => el.naam))]

  return (
    <PerMonthPerTherapistChart
      title={title}
      rawData={data}
      convertedData={convertedData}
      getPsychologists={getPsychologists}
      valueKey="omzet"
      id="revenue-psychologist-tags"
      valueFormatter={formatEuro}
      formatField="omzet"
    />
  )
}

export default RevenuePerMonthPerTherapist
